<template>
<div class="edit-area">
  <div class="container-base fullscreen"
    v-show="!previewDialogVisible">
    <h1>
      <router-link :to="{name: 'formatDetail', params: {formatId: formatId}}">{{ currentFormat.title }}</router-link>
    </h1>
    <div class="overflow-scroll-x step"
      ref="step">
      <ol>
        <li v-for="(item, index) in currentFormat.cards"
          :ref="'steps'"
          :key="item.id"
          :index="index"
          :class="{current:(item.id == currentCardId),
                     over:(index < currentCardIndex)}"
          v-ripple>
          <a href="#"
             @click="goCardTo(item.id);$event.preventDefault()">
            {{ item.title }}
          </a>
        </li>
      </ol>
    </div>
    <v-touch v-bind:enabled="{swipe:true, press:false, pan:false, tap:false, rotate:false, pinch:false}"
      v-on:swipeleft="swipeNextCard"
      v-on:swiperight="swipePrevCard"
      v-bind:swipe-options="{direction:'horizontal'}">
      <div class="cards" style="max-width: 100%;"
        v-show="currentCardId">  

        <component v-bind:is="basicInfo"
          ref="editBasic"
          :basic-data="basicData"
          :requiredBasicFields="requiredBasicFields"
          :current-card-id="currentCardId"></component>

        <component v-bind:is="currentFormat.components.edit"
          ref="editFormat"
          :basic-data="basicData"
          :format-id="formatId"
          :preview-format="$refs.previewFormat"
          :example-sentences="exampleSentences"
          :current-card-id="currentCardId"></component>

        <div id="preview-viewer"
          v-show="currentCardId == 'confirm'"
          class="preview-viewer tab-content"
          :style="previewViewerCss"
          ref="previewViewer">
          <component v-bind:is="currentFormat.components.preview"
            ref="previewConfirmFormat"
            :id-prefix="''"
            :format-data="formatData"
            :format-id="formatId"
            :basic-data="basicData"
            :preview-scale="previewScale"
            :current-card-id="currentCardId"></component>
        </div>
        <p v-show="currentCardId == 'confirm'" style="text-align: center;">수정방법은 미리보기 수정란을 클릭하거나 작성 단계를 되돌리면 수정 할 수 있습니다.</p>
        
        <div class="card-pager-nav">
          <div class="pager">
            <el-button v-ripple
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              type="primary">
              다음 <i class="el-icon-d-arrow-right"></i>
            </el-button>

            <el-button v-ripple
              icon="el-icon-d-arrow-left"
              @click="goPrevCard"
              :type="isNextCardAvailable ? 'text': 'primary'"
              :disabled="!isPrevCardAvailable">
              이전
            </el-button>
          </div>
        </div>

        <div class="text-right">
          <div class="save-time-message"
            v-show="saveNotifyMessage"
            v-if="$yagi.profile.autoSaveEnabled">
            <span>최종저장:</span> <span v-html="saveNotifyMessage"></span>
          </div>
          <div v-else>
            <el-button @click="$eventHub.$emit('open-account-dialog')"
              type="text">브라우저 자동저장:OFF</el-button>
          </div>
        </div>
        <div class="card-preview-button">
          <el-button v-ripple
            plain
            @click="showPreview"
            type="success"
            id="preview-button-format-edit"><i class="el-icon-view"></i>미리보기</el-button>
        </div>
      </div>
    </v-touch>
  </div>

  <div class="preview-dialog"
    :style="previewDialogStyleObject"
    ref="previewDialog">
    <div class="preview-action">
      <div class="container-base">
        <ul>
          <li id="close-preview-button-above">
            <el-button class="button-block"
              @click="closePreview"
              type="success"
              id="buckt-to-edit-button-format-edit"
              v-ripple><i class="el-icon-d-arrow-left"></i> 입력화면으로</el-button>
          </li>
        </ul>
      </div>
    </div>
    <div class="blog-widghet">
      <div class="blog-widghet-inner success">
        <ul class="blog-widghet-list">
          <li>
            <a class="blog-entry-link">
              <div class="left"></div>
              <div class="right">
                <div class="title">【주의!】인쇄·다운로드하기전 문서모양의 깨짐이 없는지 확인 해주세요.</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="preview-tabs">

      <input id="user-viewer-tab"
             type="radio"
             name="preview-tab-active"
             v-model="previewTabActive"
             value="previewFormat">
      <label class="tab-item"
             for="user-viewer-tab">미리보기</label>

      <input id="example-viewer-tab"
             type="radio"
             name="preview-tab-active"
             v-model="previewTabActive"
             value="sampleFormat">
      <label class="tab-item"
             for="example-viewer-tab">입력예시</label>

      <div id="preview-viewer"
        v-show="previewTabActive == 'previewFormat'"
        class="preview-viewer tab-content"
        :style="previewViewerCss"
        ref="previewViewer">
        <component v-bind:is="currentFormat.components.preview"
          ref="previewFormat"
          :id-prefix="''"
          :format-data="formatData"
          :format-id="formatId"
          :basic-data="basicData"
          :preview-scale="previewScale"
          :current-card-id="currentCardId"></component>
      </div>

      <div v-if="sampleData && previewTabActive == 'sampleFormat'"
        id="sample-viewer"
        class="sample-viewer tab-content"
        :style="previewViewerCss"
        ref="sampleViewer">
        <component v-bind:is="currentFormat.components.preview"
          ref="sampleFormat"
          :id-prefix="'sample-'"
          :is-sample="true"
          :format-id="formatId"
          :format-data="sampleData.formatData"
          :basic-data="sampleData.basicData"
          :preview-scale="previewScale"
          :current-card-id="null"></component>
      </div>
    </div>

    <div class="preview-action">
      <div class="container-base">
        <ul>
          <li v-if="$firebase.isAuthenticated">
            <el-button id="pdf-download-preview"
              class="button-block"
              type="primary"
              v-ripple
              @click="$eventHub.$emit('download-tap');"><i class="el-icon-download"></i>메일 전송 및 PDF 다운로드는 이쪽</el-button>
          </li>
          <li>
            <el-button class="button-block"
              @click="closePreview"
              type="success"
              v-ripple><i class="el-icon-d-arrow-left"></i> 입력화면으로</el-button>
          </li>
        </ul>
      </div>
    </div>

  </div>
  <div class="container-base"
    v-if="!preview">
    <div class="footer-yagi">
      <your-yagi :your-yagi-class="{}"
        :yagi-options="{dialogEnabled:true, rubyEnabled:true, messageEnabled:true}"></your-yagi>
    </div>
  </div>

  <div v-if="isDevelopment">
    <input type="button"
           @click="devAreaVisible =! devAreaVisible"
           value="debug">
    <div v-if="devAreaVisible"
      style="background:#fff;padding:20px;">
      <el-button @click="downloadPDFWithForm">downloadPDFWithForm</el-button>
      <el-button @click="downloadPDF">downloadPDF</el-button>
      <el-button @click="setPreviewHtml">서버측 HTML</el-button>

      <el-button @click="openSCREENSHOT">Open SCREENSHOT</el-button>
      <el-button @click="mailPDF"
        :disabled="this.mailPDFSending">PDF 메일전송</el-button>
      <el-button @click="loadPdfBlob">PDF 미리보기</el-button>
      <iframe v-if="pdfBlob" :src="pdfBlob" width="400px" height="600px"></iframe>
      <object v-if="pdfBlob" :data="pdfBlob" type="application/pdf" width="400px" height="600px"></object>
      <pre>{{ dumpData() }}</pre>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style scoped>
.fontbuybnr{
 width: 50%;
}

@media screen and (max-width: 480px) {
  .fontbuybnr{
  width: 100%;
  }
}
</style>
<script>
import basicInfo from '@/components/BasicInfo'
import timeAgo from '@/assets/lib/time-ago-jp'
import _ from '@/assets/lib/my-lodash'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'
// 書式1枚の高さ
const DOC_PAPER_WIDTH_PX = 794

const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'format_letter',
  'basicData',
  'recentEdit'
]

export default {
  props: {
    formatId: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: String
    }
  },
  data: function () {
    return {
      formatData: {},
      otherFormatData: {},
      formatInfo: {},
      basicData: {},
      basicInfo: basicInfo,
      requiredBasicFields: [],
      currentCardId: '',
      fontPaymented:false,
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewViewerCss: {},
      previewTabActive: 'previewFormat',
      mailPDFSending: false,
      saveNotifyMessage: '',
      saveNotifyMessageUpdateTimer: null,
      saveDate: null,
      devAreaVisible: false,
      currentFormat: {},
      downloadPdfEnabled: true,
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagish고딕'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish명조'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: '도트고딕16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagish고딕'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish명조'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: '도트고딕16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      joblistKeyword: ['건설', '게임', '엔지니어', '제작', '컨설턴트', '디자이너','청소','영업','건축','사무','접수','기획','마케팅','재무','회계 ','총무','인사','법무','홍보 ','판매','물류','운전 ','금융','미용관리 ','농업','소방관 ','경찰','공무원','NPO','드라이버'],
      pdfBlob: null,
      joblistPrefs: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外']
    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      this.updatePreviewHTML()
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      // formData.append('pdf_option', 'A4ShowPageNumberFooter')
      return formData
    },
    previewDialogStyleObject: function () {
      if (this.previewDialogVisible) {
        return {
          visibility: 'visible',
          height: 'auto'
        }
      } else {
        return {
          visibility: 'hidden',
          overflow: 'hidden',
          height: 0
        }
      }
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    },
    sampleData: function () {
      if (this.currentFormat.sampleData) {
        return this.currentFormat.sampleData
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    exampleSentences: function () {
      if (this.currentFormat.exampleSentences) {
        return this.currentFormat.exampleSentences
      }
      return {}
    },
    fisrtCardId: function () {
      return this.currentFormat.cards[0].id
    },
    isNextCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex + 1 < this.currentFormat.cards.length
    },
    isPrevCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex > 0
    },
    currentCardIndex: function () {
      if (!this.currentCardId) return -1
      let key, card
      for (key in this.currentFormat.cards) {
        card = this.currentFormat.cards[key]
        if (this.currentCardId === card.id) {
          return Number(key)
        }
      }
      return -1
    },
    currentCardTitle: function () {
      if (!this.currentCardId) return ''
      return this.currentFormat.cards[this.currentCardIndex].title
    },
    currentCardPreviewJumpId: function () {
      if (!this.currentCardId) return ''
      return this.currentFormat.cards[this.currentCardIndex].previewJumpId
    },
    nextCardLabel: function () {
      if (this.isNextCardAvailable) {
        return this.currentFormat.cards[this.currentCardIndex + 1].title
      }
      return ''
    },
    prevCardLabel: function () {
      if (this.isPrevCardAvailable) {
        return this.currentFormat.cards[this.currentCardIndex - 1].title
      }
      return ''
    }
  },
  methods: {
    preventNav(e) {
      // alert(123)
      // if (!this.$firebase.isAuthenticated) {
      //   e.preventDefault()
      //   e.returnValue = ''
      //   this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
      // }
    },
    loadCurrentFormat: function () {
      const result = this.$site.getFormatById(this.formatId)
      if (result) {
        this.currentFormat = result
      } else {
        console.error('result not found:', this.formatId, result)
      }
    },
    dumpData: function () {
      return JSON.stringify({
        'basicData': this.basicData,
        'formatData': this.formatData
      }, null, 2)
    },
    previewScrollTo: function (id) {
      if (!id) {
        return
      }
      this.$nextTick(function () {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'center'
          })
        }
      })
    },
    openIntroduction: function () {
      this.$eventHub.$emit('open-introduction-dialog', this.formatId, this.$refs.previewFormat)
    },
    showTempdata: function () {
      this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
    },
    showPreviewTest: function () {
      console.error('showPreviewTest')
      if (!this.fontPaymented) {
        this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
      }
      this.selectFont()
      this.setPreviewScale()
      this.getQrcode()
      this.$nextTick(function () {
        // this.previewScrollTo(this.currentCardPreviewJumpId)
        this.$refs.previewConfirmFormat.checkValid()
      })
    },
    showPreview: function () {
      console.error('showPreview')
      if (!this.fontPaymented) {
        this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
      }
      this.selectFont()
      this.previewDialogVisible = true
      this.previewTabActive = 'previewFormat'
      this.setPreviewScale()
      this.$router.push({
        name: 'formatPreview',
        params: {
          formatId: this.formatId,
          cardId: this.cardId
        }
      })
      this.getQrcode()
      this.$nextTick(function () {
        this.previewScrollTo(this.currentCardPreviewJumpId)
      })
      const app = this
      this.$iterateStorage(function (value, key, iterationNumber) {
          if (key === 'basicData') {
            app.username = value.lastName + '' + value.firstName
            for (const label_name in app.fontOptions) {
              // app.fontOptions[label_name].label = app.username + 'さんの履歴書（' + app.fontNames[label_name].label + '）'
              app.fontOptions[label_name].label = '이력서폰트（' + app.fontNames[label_name].label + '）'
            }
          }
      }, function (err) {})
      this.$eventHub.$emit('show-preview-from-card', this.currentCardPreviewJumpId)
    },
    showPreview4Conv: function () {
      this.$eventHub.$emit('open-eprint-dialog', this.formatId, this.$refs.previewFormat, this.formatData.selFontStyle4DB)
      // // this.displayPopup()
      // this.saveBackup()
      // this.previewDialogVisible = true
      // this.previewTabActive = 'previewFormat'
      // this.setPreviewScale()
      // this.$router.push({
      //   name: 'formatPreview',
      //   params: {
      //     formatId: this.formatId,
      //     cardId: this.cardId
      //   }
      // })
      // this.getQrcode()
      // this.$nextTick(function () {
      //   this.previewScrollTo(this.currentCardPreviewJumpId)
      // })
      // this.$eventHub.$emit('show-preview-from-card', this.currentCardPreviewJumpId)
    },
    closePreview: function () {
      this.previewDialogVisible = false
      if (this.cardId) {
        this.$router.push({
          name: 'formatEditCard',
          params: {
            formatId: this.formatId,
            cardId: this.cardId
          }
        })
      }
    },
    setRecentEdit: function (data) {
      if (!data) {
        data = {
          timestamp: new Date().getTime(),
          FormatId: this.formatId,
          FormatTitle: this.currentFormat.title,
          cardId: this.currentCardId,
          cardTitle: this.currentCardTitle
        }
      }
      this.$setItem(RECENT_EDIT_SAVE_KEY, data)
      this.$eventHub.$emit('change-recent-edit', data)
    },
    setPreviewScale: function () {
      let viewerRef = this.$refs.previewViewer
      this.$nextTick(function () {
        if (!viewerRef) return
        if (this.previewTabActive === 'sampleFormat') {
          const clientWidth = this.$refs[this.previewTabActive].$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        } else {
          const clientWidth = this.$refs.previewViewer.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      if (!this.$refs[this.previewTabActive]) {
        console.log('!this.$refs[this.previewTabActive]', this.$refs[this.previewTabActive])
        return
      }
      if (!this.$refs[this.previewTabActive].$refs.previewMain) {
        console.log('!this.$refs[this.previewTabActive].$refs.previewMain', this.$refs[this.previewTabActive].$refs.previewMain)
        return
      }
      const height = this.$refs[this.previewTabActive].$refs.previewMain.getBoundingClientRect().height
      if (!height) {
        return
      }
      this.previewViewerCss = {
        height: height + 30 + 'px'
      }
    },
    cardIdExists: function (cardId) {
      for (const key in this.currentFormat.cards) {
        if (this.currentFormat.cards[key].id === cardId) {
          return true
        }
      }
      return false
    },
    goFirstCard: function () {
      this.$router.replace({
        name: 'formatEditCard',
        params: {
          formatId: this.currentFormat.id,
          cardId: this.fisrtCardId
        }
      })
    },
    goCurrentCard: function () {
      console.error("goCurrentCard")
      if (!this.fontPaymented) {
        this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
      }
      this.selectFont()
      this.setPreviewScale()
      this.previewDialogVisible = false
      this.$router.push({
        name: 'formatEditCard',
        params: {
          formatId: this.currentFormat.id,
          cardId: this.currentCardId
        }
      })
      this.setRecentEdit()
      this.$eventHub.$emit('deactivate-history-item')
      this.$eventHub.$emit('card-changed', this.currentCardId)
      this.$nextTick(function () {
        this.showPreviewTest()
      })
    },
    scrollToCurrentStep: function () {
      this.$nextTick(function () {
        if (this.currentCardIndex < 0) {
          return
        }
        this.$refs.steps[this.currentCardIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center'
        })
      })
    },
    goCardTo: function (cardId) {
      if (!this.cardIdExists(cardId)) {
        this.goFirstCard()
        return
      }

      if (this.currentCardId == 'requests' && cardId == 'create-date' && this.getMode != 'production') {
        if (this.formatData.registYagioffer && this.formatId == 'rirekisho_job_new') {
          if (this.formatData.registYagioffer) {
            let msg = ''
            if (!this.formatData.department)  {
              msg = msg + '[학부・학과]'
            }
            if (!this.formatData.hopeAreaPref)  {
              msg = msg + '[희망근무지]'
            }
            if (!this.formatData.hopeIndustry)  {
              msg = msg + '[희망업계]'
            }
            if (!this.formatData.hopeJobcategory)  {
              msg = msg + '[희망직종]'
            }
            if (msg) {
              this.$alert('야기오퍼 등록을 하기위해、' + msg + '을 선택 해주세요', '입력에러', {
                confirmButtonText: 'OK',
                type: 'warning',
                callback: action => {
                }
              })
              return

            }

          }
          // const app = this
          // const formData = new FormData()
          // formData.append('uuid', this.$firebase.user.uid)
          // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
          // formData.append('version', '2')
          // formData.append('reqflg', '2')

          // formData.append('hope_area_pref', this.formatData.hopeAreaPref)
          // formData.append('hope_industry', this.formatData.hopeIndustry)
          // formData.append('department', this.formatData.department)
          // formData.append('hope_jobcategory', this.formatData.hopeJobcategory)
          // formData.append('graduation_year', this.formatData.gradeYear)

          // this.$axios
          //   .post(this.$varuna.endPoints.registYagiofferMember, formData, {timeout: 60000})
        }
      }

      this.currentCardId = cardId
      this.goCurrentCard()
      this.scrollToCurrentStep()
      if (!this.$firebase.isAuthenticated) {
        if (this.currentCardId == 'address' || this.currentCardId == 'license-history' ) {
          this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
        }
      }
    },
    goNextCard: function () {
      if (this.isNextCardAvailable) {

        if (this.currentFormat.cards[this.currentCardIndex + 1].id == 'create-date' && this.getMode != 'production') {
          if (this.formatData.registYagioffer && this.formatId == 'rirekisho_job_new') {
            if (this.formatData.registYagioffer) {
              let msg = ''
              if (!this.formatData.department)  {
                msg = msg + '[학부・학과]'
              }
              if (!this.formatData.hopeAreaPref)  {
                msg = msg + '[희망근무지]'
              }
              if (!this.formatData.hopeIndustry)  {
                msg = msg + '[희망업계]'
              }
              if (!this.formatData.hopeJobcategory)  {
                msg = msg + '[희망직종]'
              }
              if (msg) {
                this.$alert('야기오퍼 등록을 하기위해,' + msg + '을 선택 해주세요', '입력에러', {
                  confirmButtonText: 'OK',
                  type: 'warning',
                  callback: action => {
                  }
                })
                return

              }

            }
            // const app = this
            // const formData = new FormData()
            // formData.append('uuid', this.$firebase.user.uid)
            // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
            // formData.append('version', '2')
            // formData.append('reqflg', '2')

            // formData.append('hope_area_pref', this.formatData.hopeAreaPref)
            // formData.append('hope_industry', this.formatData.hopeIndustry)
            // formData.append('department', this.formatData.department)
            // formData.append('hope_jobcategory', this.formatData.hopeJobcategory)
            // formData.append('graduation_year', this.formatData.gradeYear)

            // this.$axios
            //   .post(this.$varuna.endPoints.registYagiofferMember, formData, {timeout: 60000})
          }
        }

        this.currentCardId = this.currentFormat.cards[this.currentCardIndex + 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
        if (!this.$firebase.isAuthenticated) {
          if (this.currentCardId == 'address' || this.currentCardId == 'license-history' || this.currentCardId == 'output') {
            this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
          }
        }
      }
    },
    goPrevCard: function () {
      if (this.isPrevCardAvailable) {
        this.currentCardId = this.currentFormat.cards[this.currentCardIndex - 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    goDownloadCard: function () {
      this.goCardTo('output')
    },
    swipeNextCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goNextCard()
      }
    },
    swipePrevCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goPrevCard()
      }
    },
    updateFormatData: function (data) {
      this.formatData = data
      this.downloadPdfEnabled = true
    },
    updateFormatOtherData: function (data) {
      console.error(data)
      this.otherFormatData = data
    },
    updateBasicData: function (data) {
      this.basicData = data
      this.downloadPdfEnabled = true
    },
    saveNotify: function () {
      const now = new Date()
      this.$setItem(LAST_SAVE_DATE_SAVE_KEY, now)
      this.saveDate = now
      this.updateSaveNotifyMessage()
    },
    updateSaveNotifyMessage: function () {
      if (this.saveDate) {
        this.saveNotifyMessage = timeAgo(this.saveDate)
      } else {
        this.saveNotifyMessage = ''
      }
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.currentFormat.id}${dateString}.${ext}`
    },
    updatePreviewHTML: function () {

      if (this.$refs.previewFormat) {
        this.previewHtml = this.$refs.previewFormat.$el.innerHTML
      } else {
        console.error('this.$refs.previewFormat', this.$refs)
      }
    },
    setPreviewHtml: function () {
      this.updatePreviewHTML()
      const param = {
        app_html: this.cleanedPreviewHtml
      }
      this.submitForm(this.$varuna.endPoints.html, param, 'POST')
    },
    saveDownloadLog: function (pdfBlob, filename) {
      // PDF Download log
      if (this.$firebase.isAuthenticated) {
        this.$firebase.addPdfDownloadLog(
          this.currentFormat.id,
          this.currentFormat.title, {
            formatData: this.formatData,
            basicData: this.basicData
          },
          pdfBlob,
          filename
        )
      }
    },
    loadPdfBlob: function () {
      /*
      PDFプレビューテスト用
      */
      const previewOpened = this.previewDialogVisible
      if (!previewOpened) {
        this.previewDialogVisible = true
      }
      const filename = this.createFilename('pdf')
      const app = this
      this.$nextTick(function () {
        this.updatePreviewHTML()
        const formData = this.pdfFormData
        formData.append('version', '2')
        formData.append('app_flag', app.$site.appFlag)
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
        let pdfurl = this.$varuna.endPoints.pdf 
        if (this.formatId == 'rirekisho_design_001') {
          pdfurl = this.$varuna.endPoints.pdfDesign 
        }
        this.$axios({
          url: pdfurl + filename,
          method: 'post',
          data: formData,
          responseType: 'blob',
          timeout: 60000
        }).then((response) => {
          const pdfBlob = new Blob([response.data], {
            type: 'application/pdf'
          })
          this.pdfBlob = window.URL.createObjectURL(pdfBlob)
        }).catch(function (error) {
          app.$message({
            message: '다운로드를 실패 하였습니다. 잠시후 다시 시도 해주세요.',
            type: 'error'
          })
          app.downloadPdfEnabled = true
          console.error(error)
          app.$gtm.sendError('pdf download', `download pdf failed ${error}`)
        })
      })
      if (!previewOpened) {
        this.previewDialogVisible = false
      }
    },
    downloadPDFWithLink: function () {
      /*
      <a download="filename">を使う
      jsでPDFのBlobを受け取れるからログに保存できる
      IEでは動かない
      */
      const previewOpened = this.previewDialogVisible
      if (!previewOpened) {
        this.previewDialogVisible = true
      }
      const filename = this.createFilename('pdf')
      const app = this
      this.$nextTick(function () {
        this.updatePreviewHTML()
        const formData = this.pdfFormData
        formData.append('version', '2')
        formData.append('format_id', app.formatId)
        formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
        if (app.$firebase.isAuthenticated) {
          formData.append('uuid', app.$firebase.user.uid)
        }
        formData.append('app_flag', app.$site.appFlag)
        formData.append('font_name', app.formatData.selFontStyle4DB)
        let pdfurl = this.$varuna.endPoints.pdf 
        if (this.formatId == 'rirekisho_design_001') {
          pdfurl = this.$varuna.endPoints.pdfDesign 
        }
        this.$axios({
          url: pdfurl + filename,
          method: 'post',
          data: formData,
          responseType: 'blob',
          timeout: 40000
        }).then((response) => {
          app.saveBackup()
          const pdfBlob = new Blob([response.data], {
            type: 'application/pdf'
          })
          if (app.$deviceLib.isMobileDevice) {
            const url = window.URL.createObjectURL(pdfBlob)
            let link = document.createElement('a')
            link.href = '/download?filename='+filename+'&blob=' + url
            link.target = '_blank'
            console.error(link)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else {
            const url = window.URL.createObjectURL(pdfBlob)
            // saveDownloadLog(pdfBlob, filename)
            let link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }).catch(function (error) {
          app.$message({
            message: '다운로드를 실패 하였습니다. 잠시후 다시 시도 해주세요.',
            type: 'error'
          })
          app.downloadPdfEnabled = true
          console.error(error)
          app.$gtm.sendError('pdf download', `download pdf failed ${error}`)
        })
      })
      if (!previewOpened) {
        this.previewDialogVisible = false
      }
    },
    downloadPDFWithForm: function (forceDownload) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '오프라인입니다. 인터넷에 접속 해주세요.',
          type: 'warning'
        })
        return
      }
      this.previewDialogVisible = true
      this.$nextTick(function () {
        this.updatePreviewHTML()
        let pdfURL = this.$varuna.endPoints.pdf
        if (forceDownload) {
          pdfURL = this.$varuna.endPoints.pdfDownload
        }
        if (this.formatId == 'rirekisho_design_001') {
          pdfURL = this.$varuna.endPoints.pdfDesign 
          if (forceDownload) {
            pdfURL = this.$varuna.endPoints.pdfDesignDownload
          }
        }
        const param = {
          app_html: this.cleanedPreviewHtml
        }
        this.submitForm(pdfURL + this.createFilename('pdf'), param, 'POST')
      })
    },
    downloadPDF: function () {
      const app = this
      // this.displayPopup()
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '오프라인입니다. 인터넷에 접속 해주세요.',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isIE) {
        this.downloadPDFWithForm(true)
      } else {
        this.downloadPDFWithLink()
      }
    },
    saveBackup: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + '의 백업'
      } else {
        this.saveLabel = '백업'
      }
      this.updatePreviewHTML()
      const app_html = this.cleanedPreviewHtml
      this.$firebase.addBackup(this.saveLabel, 'user')
    },
    keywordCheck: function (keyword) {
      let _check = false
      if (this.formatId == "shokumukeirekisho") {
        return false
      }
      for (let key in this.formatData.educationalHistories) {
        // 見出し
        let item = this.formatData.educationalHistories[key]
        if (item.description && item.description.indexOf(keyword) >= 0) {
            _check = true
        }  
      }
      for (let key in this.formatData.jobHistories) {
        // 見出し
        let item = this.formatData.jobHistories[key]
        if (item.description && item.description.indexOf(keyword) >= 0) {
            _check = true
        }
      }
      for (let key in this.formatData.licenseHistories) {
        // 見出し
        let item = this.formatData.licenseHistories[key]
        if (item.description && item.description.indexOf(keyword) >= 0) {
            _check = true
        }
      }
      return _check
    },
    keywordCheck2: function (keyword) {
      let _check = false
      if (this.formatId == "shokumukeirekisho") {
        return false
      }
      for (let key in this.formatData.educationalHistories) {
        // 見出し
        let item = this.formatData.educationalHistories[key]
        if (item.description.indexOf(keyword) >= 0) {
            _check = true
        }  
      }
      for (let key in this.formatData.licenseHistories) {
        // 見出し
        let item = this.formatData.licenseHistories[key]
        if (item.description.indexOf(keyword) >= 0) {
            _check = true
        }
      }
      return _check
    },
    keywordCheck3xx: function (keyword) {
      let _check = false
      return _check
    },
    keywordCheck3: function (keyword) {
      let _check = false
      
      if (this.formatData.prMessage && this.formatData.prMessage.indexOf(keyword) >= 0) {
          _check = true
      }
      if (this.formatData.jobSummary && this.formatData.jobSummary.indexOf(keyword) >= 0) {
          _check = true
      }
      if (this.formatData.jobHistories) {
        for (let key in this.formatData.jobHistories) {
          // 見出し
          let item = this.formatData.jobHistories[key]
          if (item && item.businessArea && item.businessArea.indexOf(keyword) >= 0) {
              _check = true
          }
          for (let subkey in item.projects) {
            let subitem = item.projects[subkey]
            if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keyword) >= 0) {
                _check = true
            }
            if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keyword) >= 0) {
                _check = true
            }
            if (subitem && subitem.position && subitem.position.indexOf(keyword) >= 0) {
                _check = true
            }
          }
        }

      }
      return _check
    },
    keywordCheckRirekisho: function (targetData, keywordlist) {
      for (const keyword in keywordlist) {
        for (let key in targetData.educationalHistories) {
          // 見出し
          let item = targetData.educationalHistories[key]
          if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
              return true
          }  
        }
        for (let key in targetData.jobHistories) {
          // 見出し
          let item = targetData.jobHistories[key]
          if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
              return true
          }
        }
        for (let key in targetData.licenseHistories) {
          // 見出し
          let item = targetData.licenseHistories[key]
          if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
              return true
          }
        }
      }
      return false
    },
    keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
      for (const keyword in keywordlist) {
        if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
            return true
        }
        if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
            return true
        }
        if (targetData.skillsToUse) {
          for (let key in targetData.skillsToUse) {
            let item = targetData.skillsToUse[key]
            if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                return true
            }
          }
        }
        if (targetData.jobHistories) {
          for (let key in targetData.jobHistories) {
            // 見出し
            let item = targetData.jobHistories[key]
            if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                return true
            }
            for (let subkey in item.projects) {
              let subitem = item.projects[subkey]
              if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                  return true
              }
              if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                  return true
              }
              if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                  return true
              }
            }
          }

        }
      }
      return false
    },
    addressCheck: function (addresslist) {
      for (const key in addresslist) {
        if (this.basicData.address1 && this.basicData.address1.indexOf(addresslist[key]) >= 0) {
          return true
        }
      }
      return false
    },
    displayPopup: async function () {
      const app = this
      if (this.getMode != 'production' && false) {
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        let storageData = {}
        await this.$iterateStorage(
          function (value, key, iterationNumber) {
            if (_.includes(BACKUP_KEYS_LIST, key)) {
              storageData[key] = value
            }
          },
          function (err) {
            if (err) {
              console.error(err)
            }
          }
        )
        formData.append('storage_data', JSON.stringify(storageData))
        this.$axios
          .post(this.$varuna.endPoints.getRtCondition, formData, {timeout: 60000})
          .then(function (response) {
            console.error(response.data)
            app.displayBackEndPopup(response.data)
          })
          .catch(function (error) {
          }).finally(function () {
          })
      } else {
        this.displayFrontEndPopup()
      }
    },
    displayFrontEndPopup: function () {
      if (this.otherFormatData.prMessage) {
        console.error(this.otherFormatData)
      } else {
        console.error(this.formatData)
      }
      let isMedley1 = false
      let isMedley2 = false
      let isMedley3 = false
      let isMedley4 = false
      let isMedley5 = false
      let isMedley6 = false
      let isMedley7 = false
      let isMedley8 = false
      let isMedley9 = false
      let isMedley10 = false
      let isTryt = false
      let isKirara = false
      let isSimple1 = false
      let isSimple2 = false
      let isSimple3 = false
      let isBaton = false
      let isBaton2 = false
      let isSystemShared = false
      let isSystemShared2 = false
      let isSystemShared3 = false
      let isSystemShared4 = false
      let isJaic1 = false
      let isJaic2 = false
      let isJaic3 = false
      let isMynaviMs = false
      let isJigen = false
      let isYagishCareer = false
      let isYagishCareer3 = false
      let isYagishCareer4 = false
      let isYagishCareer5 = false
      let medleyID = 1
      let isJob919_1 = false
      let isJob919_2 = false
      let isJob919_3 = false
      let isJob919_4 = false
      let isJob919_5 = false
      let isMiraiyu_1 = false
      let isMiraiyu_2 = false
      let isMiraiyu_3 = false
      let isMiraiyu_4 = false
      let isNeocareer_1 = false
      let isNeocareer_2 = false
      if (true) {
        if (this.keywordCheck('간병인') || this.keywordCheck('헬퍼') || this.keywordCheck('복지사')) {
          isMedley1 = true
          medleyID = 1
        } else if (this.keywordCheck('보육')) {
          isMedley2 = true
          medleyID = 2
        } else if (this.keywordCheck('약제')) {
          isMedley3 = true
          medleyID = 3
        } else if (this.keywordCheck('작업요법') || this.keywordCheck('물리요법') 
        || this.keywordCheck('언어청각')|| this.keywordCheck('시력훈련')) {
          isMedley4 = true
          medleyID = 4
        } else if (this.keywordCheck('치과위생')) {
          isMedley5 = true
          medleyID = 5
        } else if (this.keywordCheck('치과보조')) {
          isMedley6 = true
          medleyID = 6
        } else if (this.keywordCheck('간호사') || this.keywordCheck('간호조무사') ) {
          isMedley7 = true
          medleyID = 7
        }

      }
      let trytaddressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '群馬県', '千葉県', '神奈川県', '新潟県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '熊本県', '宮崎県', '沖縄県']
      if (this.addressCheck(trytaddressArray)) {
        if (this.keywordCheck2('간호사') || this.keywordCheck2('간호조무사') || this.keywordCheck2('보건사') || this.keywordCheck2('분만사')) {
          isTryt = true
        }
      }
      if (this.getMode == 'production') {
        isTryt = false
      }
      // const now = new Date()
      // const targetDate = new Date(2022, (12 - 1), 26, 10, 0)
      // if (targetDate < now) {
      //   isTryt = false
      // }
      let kiraraaddressArray = ['東京都']
      if (this.addressCheck(kiraraaddressArray)) {
        if (this.keywordCheck2('보육사')) {
          if (this.basicData.age < 50 && this.basicData.age >= 22) {
            isKirara = true
          }
        }
      }
      isKirara = false
      let simple1addressArray = ['東京都']
      if (this.addressCheck(simple1addressArray)) {
        if (this.keywordCheck('보육사')) {
          if (this.basicData.age < 60 && this.basicData.age >= 22) {
            isSimple1 = false
          }
        }
      }
      let simple2addressArray = ['神奈川県', '千葉県', '埼玉県']
      if (this.addressCheck(simple2addressArray)) {
        if (this.keywordCheck('보육사')) {
          if (this.basicData.age < 60 && this.basicData.age >= 22) {
            isSimple2 = false
          }
        }
      }
      let simple3addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
      if (this.addressCheck(simple3addressArray)) {
        if (this.keywordCheck('영양사')) {
          if (this.basicData.age < 60 && this.basicData.age >= 22) {
            isSimple3 = false
          }
        }
      }

      let batonAddressArray = ['東京都']
      if (this.addressCheck(batonAddressArray)) {
        if (this.keywordCheck('간호')) {
          isBaton = true
      }
      }
      let baton2addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
      if (this.addressCheck(baton2addressArray)) {
        if (this.keywordCheck('영업')) {
          if (this.basicData.age < 36 && this.basicData.age >= 30) {
            isBaton2 = true
          }
        }
      }
      isBaton2 = false
      let jaic1addressArray = ['宮城県', '広島県', '福岡県']
      if (this.addressCheck(jaic1addressArray)) {
        if (this.basicData.age < 30 && this.basicData.age >= 20 && this.formatId == "rerekisho_part_time") {
          isJaic1 = true
        }
      }
      let jaic2addressArray = ['宮城県', '広島県', '福岡県']
      if (this.addressCheck(jaic2addressArray)) {
        if (this.basicData.age <= 25 && this.keywordCheck('중퇴') && (this.formatId == "rirekisho_job_change" ||
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          isJaic2 = true
        }
      }
      let jaic3addressArray = ['宮城県']
      if (this.addressCheck(jaic3addressArray)) {
        if (this.basicData.age < 30 && this.basicData.age >= 20 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          isJaic3 = true
        }
      }
      isJaic1 = false
      isJaic2 = false
      isJaic3 = false
        if (this.keywordCheck('인사') || this.keywordCheck('법무') || this.keywordCheck('총무') || this.keywordCheck('경리')
            || this.keywordCheck('재무') || this.keywordCheck('노무') || this.keywordCheck('정보 시스템') ) {
            if (this.basicData.age >= 35) {
                isMynaviMs = true
            }
        }
      isMynaviMs = false

      if (this.basicData.age >= 35) {
        isJigen = true
      }
      isJigen = false

      isSystemShared = false
      if (this.keywordCheck('IT') || this.keywordCheck('엔지니어') || this.keywordCheck('설계') ||
          this.keywordCheck('PM') || this.keywordCheck('구축') || this.keywordCheck('AWS') ||
          this.keywordCheck('클라우드') || this.keywordCheck('보안') || this.keywordCheck('데이터분석') ||
          this.keywordCheck('AI') || this.keywordCheck('Python') || this.keywordCheck('PHP') ||
          this.keywordCheck('DB') || this.keywordCheck('데이터베이스') || this.keywordCheck('PL') ||
          this.keywordCheck('프로젝트리더') || this.keywordCheck('운용') || this.keywordCheck('유지보수') ||
          this.keywordCheck('Java') || this.keywordCheck('java') || this.keywordCheck('PHP') ||
          this.keywordCheck('php') || this.keywordCheck('Python') || this.keywordCheck('python') ||
          this.keywordCheck('C++') || this.keywordCheck('C#') || this.keywordCheck('Ruby') ||
          this.keywordCheck('ruby') || this.keywordCheck('Swift') || this.keywordCheck('Kotlin') ||
          this.keywordCheck('Go Linux') || this.keywordCheck('SQL') || this.keywordCheck('VB') ||
          this.keywordCheck('MySQL') || this.keywordCheck('AWS') || this.keywordCheck('정보처리기술사') ||
          this.keywordCheck('패스포트') || this.keywordCheck('기본 정보 기술자') || this.keywordCheck('응용 정보 기술자') ||
          this.keywordCheck('정보보안스페셜리스트') || this.keywordCheck('마이크로소프트 인정') ||
          this.keywordCheck('Microsoft인정') || this.keywordCheck('Google Cloud인정') || this.keywordCheck('프론트 엔드') ||
          this.keywordCheck('백엔드') || this.keywordCheck('포트폴리오') || this.keywordCheck('프리랜서') ||
          this.keywordCheck('디플로이') || this.keywordCheck('요건정의') || this.keywordCheck('빌드') ||
          this.keywordCheck('개발') || this.keywordCheck('설계') || this.keywordCheck('서버') || this.keywordCheck('SE') ||
          this.keywordCheck('프로그래밍') || this.keywordCheck('코딩')) {
          if (this.basicData.age >= 31) {
              isYagishCareer = true
          }
      }
      isYagishCareer = false


      let yagishCareer3addressArray = ['東京都']
      if (this.addressCheck(yagishCareer3addressArray)) {
        if (this.keywordCheck('복지사')) {
          if (this.basicData.age < 60 && this.basicData.age >= 31) {
            isYagishCareer3 = true
          }
        }
      }
      let yagishCareer4addressArray = ['東京都']
      if (this.addressCheck(yagishCareer4addressArray)) {
        if (this.keywordCheck('물리요법')) {
          if (this.basicData.age < 60 && this.basicData.age >= 31) {
            isYagishCareer4 = true
          }
        }
      }
      let yagishCareer5addressArray = ['東京都']
      if (this.addressCheck(yagishCareer5addressArray)) {
        if (this.keywordCheck('작업요법')) {
          if (this.basicData.age < 60 && this.basicData.age >= 31) {
            isYagishCareer5 = true
          }
        }
      }

      let systemShared2addressArray = ['北海道', '青森県', '秋田県', '宮城県', '山形県', '福島県', '岩手県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '長野県', '山梨県', '岐阜県', '福井県', '静岡県', '広島県', '岡山県', '鳥取県', '島根県', '山口県', '愛媛県', '徳島県', '香川県', '高知県', '福岡県', '佐賀県', '大分県', '長崎県', '熊本県', '宮崎県', '鹿児島県', '沖縄県']
      if (this.addressCheck(systemShared2addressArray)) {
        if (this.basicData.age < 30 && this.basicData.age >= 20) {
          isSystemShared2 = true
        }
      }
      isSystemShared2 = false
      let systemShared3addressArray = ['東京都', '神奈川県', '千葉県', '茨城県', '群馬県', '埼玉県', '栃木県']
      if (this.addressCheck(systemShared3addressArray)) {
        if (this.formatData.gradeYear == 23) {
          isSystemShared3 = true
        } else {
          if (this.basicData.age >= 22) {
            isSystemShared3 = true
          }
        }
      }
      isSystemShared3 = false
      let systemShared4addressArray = ['東京都', '神奈川県', '千葉県', '茨城県', '群馬県', '埼玉県', '栃木県']
      let systemShared4KeywordArray = ['엔지니어', '프로그래밍', 'JAVA', 'C#', 'AWS', '클라우드', 'salesforce', '세일즈 포스', '컨설팅', 'PG', 'SE', 'PM', 'PL', '강사', '교원 면허', '교론 면허', '소프트웨어개발', '기본 정보', '응용 정보', 'ORACLE', 'Python', 'C언어', 'C++', 'SQL']
      // if (this.keywordCheck('エンジニア') || this.keywordCheck('プログラミング') || this.keywordCheck('JAVA') || this.keywordCheck('C#') || this.keywordCheck('AWS') || 
      // this.keywordCheck('クラウド') || this.keywordCheck('salesforce') || this.keywordCheck('セールスフォース') || 
      // this.keywordCheck('コンサル') || this.keywordCheck('PG') || this.keywordCheck('SE') || this.keywordCheck('PM') || this.keywordCheck('PL') || 
      // this.keywordCheck('講師') || this.keywordCheck('教員免許') || this.keywordCheck('教論免許') || this.keywordCheck('ソフトウェア開発') || 
      // this.keywordCheck('基本情報') || this.keywordCheck('応用情報') || this.keywordCheck('ORACLE') || this.keywordCheck('Python') || this.keywordCheck('C言語') || 
      // this.keywordCheck('C++') || this.keywordCheck('SQL') || this.keywordCheck('日商簿記2級')) {
      //   if (this.addressCheck(systemShared4addressArray)) {
      //     if (this.basicData.age >= 18 && this.basicData.age <= 35) {
      //       isSystemShared4 = true
      //     }
      //   }
      // }

      if (this.addressCheck(systemShared4addressArray)) {
        if (this.basicData.age >= 18 && this.basicData.age <= 35) {
          if (this.formatId.indexOf('shokumukeirekisho') >= 0) {
            // 職務経歴書
            if (this.keywordCheckShokumukeirekisho(this.formatData, systemShared4KeywordArray)) {
              isSystemShared4 = true
            }
            if (!isSystemShared4) {
              if (this.keywordCheckRirekisho(this.otherFormatData, systemShared4KeywordArray)) {
                isSystemShared4 = true
              }
            }
          } else {
            // 履歴書
            if (this.keywordCheckRirekisho(this.formatData, systemShared4KeywordArray)) {
              isSystemShared4 = true
            }
            if (!isSystemShared4) {
              if (this.keywordCheckShokumukeirekisho(this.otherFormatData, systemShared4KeywordArray)) {
                isSystemShared4 = true
              }
            }
            
          }

        }
      }



      if (this.keywordCheck('시공관리') || this.keywordCheck('감리기술자')) {
        if (this.basicData.age <= 65 && this.basicData.age >= 20) {
          isJob919_1 = true
        }
      }
      let job919addressArray = ['愛知県', '秋田県', '青森県', '千葉県', '福岡県', '福島県', '群馬県', '広島県', '北海道', '兵庫県', '茨城県', '岩手県', '神奈川県', '京都府', '宮城県', '長野県', '奈良県', '新潟県', '岡山県', '大阪府', '埼玉県', '静岡県', '栃木県', '東京都', '山形県']
      if (this.keywordCheck('자동차정비사')) {
        if (this.addressCheck(job919addressArray)) {
          if (this.basicData.age <= 49 && this.basicData.age >= 20) {
            isJob919_2 = true
          }
        }
      }
      if (this.keywordCheck('건축사')) {
        if (this.basicData.age <= 65 && this.basicData.age >= 20) {
          isJob919_3 = true
        }
      }
      if (this.keywordCheck('전기기술자')) {
        if (this.basicData.age <= 65 && this.basicData.age >= 20) {
          isJob919_4 = true
        }
      }
      let job919_5_addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '岐阜県', '静岡県', '大阪府', '京都府', '兵庫県', '奈良県']
      if (this.keywordCheck('간호사')) {
        if (this.addressCheck(job919_5_addressArray)) {
          if (this.basicData.age <= 39 && this.basicData.age >= 25) {
            isJob919_5 = true
          }
        }
      }
      isJob919_5 = false

      if (this.keywordCheck('운전')) {
        if (this.basicData.age <= 59 && this.basicData.age >= 31) {
          isMiraiyu_1 = false
        }
      }
      let miraiyu2addressArray = ['東京都', '千葉県', '神奈川県', '埼玉県']
      if (this.addressCheck(miraiyu2addressArray)) {
        if (this.basicData.age == 18) {
          isMiraiyu_2 = false
        }
        if (this.keywordCheck('화물') || this.keywordCheck('트럭') || this.keywordCheck('배송') || this.keywordCheck('장거리') || this.keywordCheck('운송') || this.keywordCheck('문류') || this.keywordCheck('택배') || this.keywordCheck('운수') || this.keywordCheck('대형 면허') || this.keywordCheck('픽업') || this.keywordCheck('특급우편') || this.keywordCheck('운행관리') || this.keywordCheck('운전 기사') || this.keywordCheck('로지스틱스')) {
            if (this.keywordCheck('보통 면허') || this.keywordCheck('준중형 면허') || this.keywordCheck('중형 면허') || this.keywordCheck('대형 면허') || this.keywordCheck('대형 특수 면허') || this.keywordCheck('견인 면허') || this.keywordCheck('2종보통') || this.keywordCheck('1종대형') || this.keywordCheck('2종 수동면허') || this.keywordCheck('大型特殊第二種免許') || this.keywordCheck('대형특수면허')) {
                if (this.basicData.age >= 20 && this.basicData.age <= 59) {
                    isMiraiyu_3 = true
                }
            }
        }
        if (this.keywordCheck('택시') || this.keywordCheck('교통') || this.keywordCheck('렌탈')) {
            if (this.keywordCheck('보통 면허') || this.keywordCheck('준중형 면허') || this.keywordCheck('중형 면허') || this.keywordCheck('대형 면허') || this.keywordCheck('대형 특수 면허') || this.keywordCheck('견인 면허') || this.keywordCheck('2종보통') || this.keywordCheck('1종대형') || this.keywordCheck('2종 수동면허') || this.keywordCheck('대형면허') || this.keywordCheck('대형특수면허')) {
                if (this.basicData.age >= 20 && this.basicData.age <= 59) {
                    isMiraiyu_4 = true
                }
            }
        }
        
      }
      


      let isAdtop = false
      if (this.basicData.age < 35) {
        isAdtop = true
      }
      isAdtop = false

      let isRoxx = false
      let roxxaddressArray = ['東京都', '埼玉県', '神奈川県', '千葉県', '大阪府', '京都府', '兵庫県', '和歌山県', '奈良県', '滋賀県', '名古屋市', '北九州市', '札幌市', '福岡市', '広島市', '仙台市', '静岡市', '新潟市', '浜松市', '岡山市', '熊本市']
      if (this.addressCheck(roxxaddressArray)) {
        if (this.basicData.age >= 19 && this.basicData.age <= 30) {
          isRoxx = true
        }
      }

      let isRoxx2 = false
      let roxxaddressArray2 = ['東京都', '埼玉県', '神奈川県', '千葉県', '大阪府', '京都府', '兵庫県', '和歌山県', '奈良県', '滋賀県', '名古屋市', '北九州市', '札幌市', '福岡市', '広島市', '仙台市', '静岡市', '新潟市', '浜松市', '岡山市', '熊本市']
      if (this.addressCheck(roxxaddressArray2)) {
        if (this.basicData.age >= 31 && this.basicData.age <= 34) {
          isRoxx2 = true
        }
      }

      if (this.formatData.gradeYear == 24) {
        if (this.basicData.email &&
        this.basicData.tel1 &&
        this.basicData.tel2 &&
        this.basicData.tel3 &&
        this.basicData.lastName &&
        this.basicData.firstName) {
          let isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
          if (this.addressCheck(isNeocareerAddressArray2)) {
            if (this.basicData.age <= 25 && !this.formatData.foreignStudent) {
              isNeocareer_1 = true
            }
          }
        }
      }
      if (this.basicData.email &&
      this.basicData.tel1 &&
      this.basicData.tel2 &&
      this.basicData.tel3 &&
      this.basicData.lastName &&
      this.basicData.firstName) {
        let isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
        if (this.addressCheck(isNeocareerAddressArray2)) {
          if (this.basicData.age <= 25) {
            if (this.keywordCheck('2024년 졸업예정') || this.keywordCheck('2024년 졸업예정')) {
              isNeocareer_2 = true
            }
          }
        }
      }

      let isYagishSaiyo1 = false
      let isYagishSaiyo2 = false

      if (this.keywordCheck3('영업') || this.keywordCheck3('판매')) {
        isYagishSaiyo1 = false
      }
      if (this.keywordCheck3('분석') || this.keywordCheck3('디렉터') || this.keywordCheck3('GA') || this.keywordCheck3('구글 애널리틱스') || this.keywordCheck3('Google애널리틱스') || this.keywordCheck3('UI・UX설계') || this.keywordCheck3('유저테스트') || this.keywordCheck3('SEO')) {
        isYagishSaiyo2 = true
      }

      if (isTryt && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-tryt-dialog', this.formatId, this.$refs.previewFormat)
      } else if (isJob919_5 && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-jobs919-dialog', this.formatId, this.$refs.previewFormat, 5)
      } else if (isSystemShared4 && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-systemshared-dialog', this.formatId, this.$refs.previewFormat, 4)
      } else if (isMiraiyu_3 && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-miraiyu-dialog', this.formatId, this.$refs.previewFormat, 3)
      } else if (isMiraiyu_4 && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-miraiyu-dialog', this.formatId, this.$refs.previewFormat, 4)
      } else if (isRoxx2 && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-roxx-dialog', this.formatId, this.$refs.previewFormat, this.basicData.email, 2)
      } else if (isRoxx && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-roxx-dialog', this.formatId, this.$refs.previewFormat, this.basicData.email, 1)
      } else if (isKirara && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-kirara-dialog', this.formatId, this.$refs.previewFormat)
      } else if (isSimple1 && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-simple-dialog', this.formatId, this.$refs.previewFormat, 1)
      } else if (isSimple2 && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-simple-dialog', this.formatId, this.$refs.previewFormat, 2)
      } else if (isSimple3 && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-simple-dialog', this.formatId, this.$refs.previewFormat, 3)
      } else if (isBaton && (this.formatId == "rirekisho_job_change" || 
        this.formatId == "rirekisho_job_change2" || 
        this.formatId == "rirekisho_job_change_old" || 
        this.formatId == "rirekisho_single" || 
        this.formatId == "rirekisho_nophoto_double" || 
        this.formatId == "rirekisho_nophoto")) {
        this.$eventHub.$emit('open-baton-dialog', this.formatId, this.$refs.previewFormat, 1)
      } else if (isJaic1) {
        this.$eventHub.$emit('open-jaic-dialog', this.formatId, this.$refs.previewFormat, 1)
      } else if (isJaic2) {
        this.$eventHub.$emit('open-jaic-dialog', this.formatId, this.$refs.previewFormat, 2)
      } else if (isJaic3) {
        this.$eventHub.$emit('open-jaic-dialog', this.formatId, this.$refs.previewFormat, 3)
      } else {
        if (isYagishCareer3 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-yagishcareer-dialog', this.formatId, this.$refs.previewFormat, 3)
        } else if (isYagishCareer4 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-yagishcareer-dialog', this.formatId, this.$refs.previewFormat, 4)
        } else if (isYagishCareer5 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-yagishcareer-dialog', this.formatId, this.$refs.previewFormat, 5)
        } else if (isJob919_1 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-jobs919-dialog', this.formatId, this.$refs.previewFormat, 1)
        } else if (isJob919_2 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-jobs919-dialog', this.formatId, this.$refs.previewFormat, 2)
        } else if (isJob919_3 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-jobs919-dialog', this.formatId, this.$refs.previewFormat, 3)
        } else if (isJob919_4 && (this.formatId == "rirekisho_job_change" ||
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-jobs919-dialog', this.formatId, this.$refs.previewFormat, 4)
        } else if (isBaton2 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-baton-dialog', this.formatId, this.$refs.previewFormat, 2)
        } else if (isSystemShared && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-systemshared-dialog', this.formatId, this.$refs.previewFormat, 1)
        } else if (isYagishCareer && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-yagishcareer-dialog', this.formatId, this.$refs.previewFormat, 2)
        } else if (isSystemShared2 && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
            if (this.basicData.sex == 1) {
              this.$eventHub.$emit('open-systemshared-dialog', this.formatId, this.$refs.previewFormat, 2)
            } else {
              this.$eventHub.$emit('open-systemshared-dialog', this.formatId, this.$refs.previewFormat, 3)
            } 
        } else if (isSystemShared3 && (this.formatId == "rirekisho_job_new" || 
         this.formatId == "rirekisho_job_new_single")) {
            if (this.basicData.sex == 1) {
              this.$eventHub.$emit('open-systemshared-dialog', this.formatId, this.$refs.previewFormat, 2)
            } else {
              this.$eventHub.$emit('open-systemshared-dialog', this.formatId, this.$refs.previewFormat, 3)
            } 
        } else if(isAdtop && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-adtop-dialog', this.formatId, this.$refs.previewFormat)
        } else if (isMynaviMs && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-mynavi-ms-dialog', this.formatId, this.$refs.previewFormat)
        } else if (isJigen && (this.formatId == "rirekisho_job_change" || 
          this.formatId == "rirekisho_job_change2" || 
          this.formatId == "rirekisho_job_change_old" || 
          this.formatId == "rirekisho_single" || 
          this.formatId == "rirekisho_nophoto_double" || 
          this.formatId == "rirekisho_nophoto")) {
          this.$eventHub.$emit('open-jigen-dialog', this.formatId, this.$refs.previewFormat, 2)
        } else if ((isMedley1 || isMedley2 || isMedley3 || isMedley4 || isMedley5 || isMedley6 || isMedley7 || isMedley8 || isMedley9 || isMedley10)
        && !(this.formatId == "rirekisho_job_new" || this.formatId == "rirekisho_job_new_single" || this.formatId == "internship")) {
          this.$eventHub.$emit('open-medley-dialog', this.formatId, this.$refs.previewFormat, medleyID)
        } else if ((this.formatId == "rirekisho_job_new" ||  this.formatId == "rirekisho_job_new_single") && isNeocareer_1) {
          this.$eventHub.$emit('open-neocareer-dialog', this.formatId, this.$refs.previewFormat, 1, this.formatData.gradeYear)
          // var athlete_univ_id  = this.$cookies.get('_YAGISH_ATHLETE_UNIVID')
          // if (athlete_univ_id) {
          //   this.$eventHub.$emit('open-athlete-dialog', this.formatId, this.$refs.previewFormat)
          // } else {
          //   this.$eventHub.$emit('open-newgrade-dialog', this.formatId, this.$refs.previewFormat, this.basicData.email, this.formatData.gradeYear)
          // }
        } else if ((this.formatId == "rerekisho_part_time") && isNeocareer_2) {
          this.$eventHub.$emit('open-neocareer-dialog', this.formatId, this.$refs.previewFormat, 2, this.formatData.gradeYear)
          // var athlete_univ_id  = this.$cookies.get('_YAGISH_ATHLETE_UNIVID')
          // if (athlete_univ_id) {
          //   this.$eventHub.$emit('open-athlete-dialog', this.formatId, this.$refs.previewFormat)
          // } else {
          //   this.$eventHub.$emit('open-newgrade-dialog', this.formatId, this.$refs.previewFormat, this.basicData.email, this.formatData.gradeYear)
          // }
        } else if (this.formatId == "shokumukeirekisho") {
          this.$eventHub.$emit('open-etc-dialog', this.formatId, this.$refs.previewFormat)
        } else {
            console.error('open-joblist-dialog')
            this.$eventHub.$emit('open-joblist-dialog', this.formatId, this.$refs.previewFormat, this.checkJoblistKeyword(), this.getPrefJoblist(), this.basicData.age)
        }
      }
      if (this.formatId == "shokumukeirekisho") {
        console.error(this.formatData)
        if (isYagishSaiyo2) {
          this.$eventHub.$emit('open-yagish-dialog', this.formatId, this.$refs.previewFormat, 6)
        } else if (isYagishSaiyo1) {
          this.$eventHub.$emit('open-yagish-dialog', this.formatId, this.$refs.previewFormat, 5)
        } else {
          // this.$eventHub.$emit('open-etc-dialog', this.formatId, this.$refs.previewFormat)
          this.$eventHub.$emit('open-joblist-dialog', this.formatId, this.$refs.previewFormat, this.checkJoblistKeyword(), this.getPrefJoblist(), this.basicData.age)
        }
      }
     
      // if (this.formatId == "rerekisho_part_time" || this.formatId == "rirekisho_part_time2") {
      //   this.$eventHub.$emit('open-jigen-dialog', this.formatId, this.$refs.previewFormat, 1)
      // }
    },
    displayBackEndPopup: function (data) {
      console.error(data.client_condition_id)
      console.error(data.permission_type)
      let dialogName = data.dialog_name
      let permissionType = data.permission_type
      if (dialogName=='roxx_dialog') {
        this.$eventHub.$emit('open-roxx-dialog', this.formatId, this.$refs.previewFormat, this.basicData.email, permissionType)
      } else if (dialogName=='kirara_dialog') {
        this.$eventHub.$emit('open-kirara-dialog', this.formatId, this.$refs.previewFormat)
      } else if (dialogName=='simple_dialog') {
        this.$eventHub.$emit('open-simple-dialog', this.formatId, this.$refs.previewFormat, permissionType)
      } else if (dialogName=='baton_dialog' && permissionType == 1) {
        this.$eventHub.$emit('open-baton-dialog', this.formatId, this.$refs.previewFormat, 1)
      } else if (dialogName=='medley_dialog') {
        this.$eventHub.$emit('open-medley-dialog', this.formatId, this.$refs.previewFormat, 1)
      } else {
        this.$eventHub.$emit('open-joblist-dialog', this.formatId, this.$refs.previewFormat, this.checkJoblistKeyword(), this.getPrefJoblist(), this.basicData.age)
      }
      
    },
    checkJoblistKeyword: function () {
      let _keyword = ''
      for (let key in this.joblistKeyword) {
        if (this.keywordCheck(this.joblistKeyword[key])) {
          _keyword = this.joblistKeyword[key]
          return _keyword
        }  
      }
      return _keyword
    },
    getPrefJoblist: function () {
      let _pref = ''
      for (let key in this.joblistPrefs) {
        if (this.basicData.address1.indexOf(this.joblistPrefs[key]) >= 0) {
            _pref = this.joblistPrefs[key]
        }  
      }
      return _pref
    },
    mailPDF: async function () {
      const app = this
      this.displayPopup()
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '오프라인입니다. 인터넷에 접속 해주세요.',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: '로그인 해주세요.',
          type: 'warning'
        })
        return
      }
      if (this.mailPDFSending) {
        this.$message({
          message: '메일을 전송하고 있습니다.',
          type: 'error'
        })
        return
      }
      if (!this.$firebase.user.email) {
        if (!app.basicData.email) {
          this.$message({
            message: '연락처에 메일주소를 입력 해주세요.',
            type: 'error'
          })
          return
        }
      } else {
        if (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && !app.basicData.email) {
          this.$message({
            message: '연락처에 메일주소를 입력 해주세요.',
            type: 'error'
          })
          return
        }
      }
      this.updatePreviewHTML()
      console.error(app.basicData)
      console.error(app.formatData)
      this.mailPDFSending = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('format_id', this.formatId)
      if (!this.$firebase.user.email && app.basicData.email || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && app.basicData.email)) {
        formData.append('inputemail', app.basicData.email)
        const subformData = new FormData()
        subformData.append('uuid', this.$firebase.user.uid)
        subformData.append('email', app.basicData.email)
        subformData.append('app_flag', this.$site.appFlag)
        subformData.append('site_flag', 'c')
        subformData.append('email_verified', this.$firebase.useremailVerified?'1':'0')
        subformData.append('device_flag', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
        this.$axios
          .post(this.$varuna.endPoints.login, subformData)
        // this.$firebase.user.updateEmail(app.basicData.email).then(() => {
        // }).catch((error) => {
        // });
      }
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('font_name', app.formatData.selFontStyle4DB)
      formData.append('site_flag', 'c')
      formData.append('version', '2')
      
      formData.append('keyword', this.checkJoblistKeyword())
      formData.append('area', this.getPrefJoblist())
      if (this.formatId == "rerekisho_part_time" || 
        this.formatId == "rirekisho_part_time2") {
        formData.append('jt', '2')
      } else if (this.formatId == "rirekisho_job_new" ||  
        this.formatId == "rirekisho_job_new_single" ||  
        this.formatId == "internship") {
        formData.append('jt', '6')
      } else {
        formData.append('jt', '0')
      }

      app.saveBackup()
      let pdfurl = this.$varuna.endPoints.pdfMail
      if (this.formatId == 'rirekisho_design_001') {
        pdfurl = this.$varuna.endPoints.pdfDesignMail 
      }
      this.$axios
        .post(pdfurl, formData, {timeout: 60000})
        .then(function (response) {
          if (!app.$firebase.user.email && app.basicData.email || 
            (app.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && app.basicData.email)) {
            app.$message({
              message: app.basicData.email + '에 전송하였습니다',
              type: 'success'
            })
          } else {
            app.$message({
              message: app.$firebase.user.email + '에 전송하였습니다',
              type: 'success'
            })
          }
        })
        .catch(function (error) {
          app.$message({
            message: '전송을 실패하였습니다',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.mailPDFSending = false
        })
    },
    openSCREENSHOT: function () {
      this.updatePreviewHTML()
      const param = {
        app_html: this.cleanedPreviewHtml
      }
      this.submitForm(this.$varuna.endPoints.screenshot + this.createFilename('png'), param, 'POST')
    },
    submitForm: function (url, data, method) {
      const form = document.createElement('form')
      document.body.appendChild(form)
      form.action = url
      form.method = method
      for (const name in data) {
        let input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.value = data[name]
        form.appendChild(input)
      }
      form.submit()
      document.body.removeChild(form)
    },
    hidePreviewDialog: function (e) {
      if (this.previewDialogVisible) {
        this.previewDialogVisible = false
      }
    },
    selectFont: function() {
      const app = this
      this.formatData.selFontStyle = this.formatData.selFont
      this.formatData.selFontStyle4DB = this.formatData.selFont
      
      for (const label_name in this.fontOptions) {
        if (this.fontNames[label_name].value == this.formatData.selFont) {
          this.formatData.selectedFontName = '선택한 폰트（' + this.fontNames[label_name].label + '）'
          this.formatData.selFontStyle4DB = this.fontNames[label_name].label
        }
      }
    },
    setPreviewScaleDebounce: function (e) {
      _.debounce(this.setPreviewScale, 1000)
    },
    sendSpecialPost: function (formatId) {
      this.saveBackup()
      // this.displayPopup()
      this.$router.push('/quickmail/basic')
    },
    sendQuickEmail: function (formatId) {
      this.saveBackup()
      // this.displayPopup()
      this.$router.push('/quickemail/basic')
    },
    getQrcode: function () {
      console.error("getQrcode:"+this.$firebase.user.uid)
      if (this.$firebase.isAuthenticated) {
        const app = this
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
        formData.append('version', '2')
        formData.append('reqflg', '2')

        this.$axios
          .post(this.$varuna.endPoints.getQRcode, formData, {timeout: 60000})
          .then(function (response) {
            if (response.data != 'errors:DoesNotExist') {
              app.$refs.previewFormat.qr_image = 'data:image/png;base64,' + response.data.qr
              app.$refs.previewFormat.qr_link = response.data.link
            }
          })
          .catch(function (error) {
            console.log(error)
          }).finally(function () {
            app.fullscreenLoading = false
          })
      }
    },
    getFontpayment: function () {
      
      this.$nextTick(function () {
        console.error(this.$firebase.isAuthenticated)
        if (this.$firebase.isAuthenticated) {
          const app = this

          const formData = new FormData()
          formData.append('uuid', this.$firebase.user.uid)

          this.$axios
            .post(this.$varuna.endPoints.getFontpayment, formData, {timeout: 60000})
            .then(function (response) {
              console.error(response.data.payment_flag)
              if (response.data.payment_flag == '1') {
                app.fontPaymented = true
              }
            })
            .catch(function (error) {
            }).finally(function () {
            })
          
        }
      })
    },
    sendYagishIntern: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '오프라인입니다. 인터넷에 접속 해주세요.',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: '로그인 해주세요.',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatId)
      formData.append('yaginame', '지원자')
      formData.append('client_id', 'yagish_intern')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'intern_page')
      formData.append('permission_type', 4)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.yagishRecruitPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          // app.isYagishCareerSended = true
          app.$eventHub.$emit('set_is_sendedYagishIntern', true)
        })
        .catch(function (error) {
          app.$message({
            message: '전송을 실패하였습니다',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendEmailVerification: async function() {
      const app = this
      await this.$firebase.user.sendEmailVerification().then(() => {
        app.$message({
          message: '전송하였습니다. 메일내의 링크를 클릭해 주세요.',
          type: 'success'
        })
        
      }).catch((error) => {
        app.$message({
          message: '전송을 실패하였습니다。',
          type: 'error'
        })
      })
    },
    getFontPaymented: function() {
      console.error("getFontPaymented:" + this.fontPaymented)
      return this.fontPaymented
    }
  },
  watch: {
    'cardId': function () {
      this.currentCardId = this.cardId
      if (this.currentCardIndex < 0) {
        this.goFirstCard()
      }
    },
    previewTabActive: function () {
      this.setPreviewScale()
    }
  },
  beforeMount: function () {
    this.loadCurrentFormat()
    if (this.currentFormat) {
      this.requiredBasicFields = this.currentFormat['requiredBasicFields']
    }
    if (this.cardId) {
      this.currentCardId = this.cardId
    }
    if (!this.$firebase.isAuthenticated) {
      if (this.currentCardId != 'profile' && this.currentCardId != '' && this.currentCardId != 'letterprofile' && this.currentCardId != 'output') {
        // console.error('open-tempdata-dialog：' + this.currentCardId)
        // this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
      }

    } 
    window.addEventListener("beforeunload", this.preventNav)
  },
  beforeDestroy() {
    // Don't forget to clean up event listeners
    window.removeEventListener("beforeunload", this.preventNav)
  },
  created : function(){
    console.log('created')
    this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
    this.selectFont()
    this.getFontpayment()
    if (this.currentCardId == 'confirm') {
      // this.setPreviewScale()
      this.showPreviewTest()
    }
  },
  mounted: function () {
    if (this.currentCardIndex < 0) {
      this.goFirstCard()
    }
    console.error("mounted:"+this.$firebase.isAuthenticated)
    this.$eventHub.$on('get_fontpayment', this.getFontpayment)
    this.$eventHub.$on('local-format-data-loaded', this.setPreviewHeight)
    this.$eventHub.$on('basic-data-changed', this.updateBasicData)
    this.$eventHub.$on('format-data-changed', this.updateFormatData)
    this.$eventHub.$on('format-otherdata-changed', this.updateFormatOtherData)
    this.$eventHub.$on('backup-loaded-' + RECENT_EDIT_SAVE_KEY, this.setRecentEdit)
    this.$eventHub.$on('save-complete-notify', this.saveNotify)
    this.$eventHub.$on('download-PDF', this.downloadPDF)
    this.$eventHub.$on('download-tap', this.goDownloadCard)
    this.$eventHub.$on('mail-PDF', this.mailPDF)
    this.$eventHub.$on('send-special-post', this.sendSpecialPost)
    this.$eventHub.$on('send-special-quickemail', this.sendQuickEmail)
    this.$eventHub.$on('go-card-to', this.goCardTo)
    this.$eventHub.$on('show-preview', this.showPreview)
    this.$eventHub.$on('select-font', this.selectFont)
    this.$eventHub.$on('show-preview-4conv', this.showPreview4Conv)
    this.$eventHub.$on('get_font_paymented', this.getFontPaymented)
    this.$eventHub.$on('go-quickmail-page', this.goQuickmailPage)
    this.$eventHub.$on('send-yagish-intern', this.sendYagishIntern)
    this.$eventHub.$on('send-email-verification', this.sendEmailVerification)
    if (this.preview === false) {
      this.closePreview()
    } else if (this.preview === true) {
      this.showPreview()
    } 
    if (this.currentCardId == 'confirm') {
      // this.setPreviewScale()
      this.showPreviewTest()
    }
    const app = this
    this.$getItem(LAST_SAVE_DATE_SAVE_KEY, function (err, data) {
      if (err) {
        console.error(err)
        return
      }
      app.saveDate = data
      app.updateSaveNotifyMessage()
    })
    // set event listeners and timer
    window.addEventListener('popstate', this.hidePreviewDialog, false)
    window.addEventListener('resize', this.setPreviewScaleDebounce, false)
    this.saveNotifyMessageUpdateTimer = setInterval(this.updateSaveNotifyMessage, 5000)
    this.scrollToCurrentStep()
    console.error("mounted:"+this.$firebase.isAuthenticated)
  },
  destroyed: function () {
    // remove event listeners and timer
    this.$eventHub.$off('get_fontpayment', this.getFontpayment)
    this.$eventHub.$off('local-format-data-loaded', this.setPreviewHeight)
    this.$eventHub.$off('basic-data-changed', this.updateBasicData)
    this.$eventHub.$off('format-data-changed', this.updateFormatData)
    this.$eventHub.$off('format-otherdata-changed', this.updateFormatOtherData)
    this.$eventHub.$off('backup-loaded-' + RECENT_EDIT_SAVE_KEY, this.setRecentEdit)
    this.$eventHub.$off('save-complete-notify', this.saveNotify)
    this.$eventHub.$off('download-PDF', this.downloadPDF)
    this.$eventHub.$off('download-tap', this.goDownloadCard)
    this.$eventHub.$off('mail-PDF', this.mailPDF)
    this.$eventHub.$off('send-special-post', this.sendSpecialPost)
    this.$eventHub.$off('send-special-quickemail', this.sendQuickEmail)
    this.$eventHub.$off('go-card-to', this.goCardTo)
    this.$eventHub.$off('show-preview', this.showPreview)
    this.$eventHub.$off('get_font_paymented', this.getFontPaymented)
    this.$eventHub.$off('select-font', this.selectFont)
    this.$eventHub.$off('show-preview-4conv', this.showPreview4Conv)
    this.$eventHub.$off('go-quickmail-page', this.goQuickmailPage)
    this.$eventHub.$off('send-yagish-intern', this.sendYagishIntern)
    this.$eventHub.$off('send-email-verification', this.sendEmailVerification)
    window.removeEventListener('popstate', this.hidePreviewDialog, false)
    window.removeEventListener('resize', this.setPreviewScaleDebounce, false)
    clearInterval(this.saveNotifyMessageUpdateTimer)
  }
}
</script>
